import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { useConfig } from 'common/hooks';

import PodiumWrapper from '../common/PodiumWrapper';
import Podium from '../common/Podium';

const deps = {
  leaderboard: state.challenge.visualisations.computedLeaderboardChallenge,
};

function PodiumChallenge({
  leaderboard,
}: typeof deps & ConnectedProps): React.ReactElement {
  const { staticUrl } = useConfig();

  const top3 = leaderboard.long.slice(0, 3);

  return (
    <PodiumWrapper
      imageSrc={`${staticUrl}/images/challenge/graphBackground/sectionBackground.png`}
    >
      <Podium top3={top3} colors={['#4CAF50', '#E8F5E9']} />
    </PodiumWrapper>
  );
}

export default connect(deps, PodiumChallenge);
